import { LookupsService } from '@zayan-erp/shared';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as WarrantyActions from './warranty.actions';
import { of } from 'rxjs';
import { map, switchMap, withLatestFrom } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import {
  selectWarrantyTypes,
  selectDeficiencyCode,
  selectCategoryLocation,
  selectLocations
} from './warranty.selectors';

@Injectable()
export class WarrantyEffects {
  private actions$ = inject(Actions);
  private lookupsService = inject(LookupsService);
  store = inject(Store);
  warrantyTypes$ = this.store.select(selectWarrantyTypes);
  deficiencyCode$ = this.store.select(selectDeficiencyCode);
  Locations$ = this.store.select(selectLocations);

  loadWarrantyTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(WarrantyActions.loadWarrantyTypes),
      withLatestFrom(this.warrantyTypes$),
      switchMap(() =>
        this.lookupsService
          .readLookupWarrantyTypes()
          .pipe(map(warrantyTypes => WarrantyActions.loadWarrantyTypesSuccess({ warrantyTypes })))
      )
    )
  );
  loadDeficiencyCode$ = createEffect(() =>
    this.actions$.pipe(
      ofType(WarrantyActions.loadDeficiencyCode),
      withLatestFrom(this.deficiencyCode$),
      switchMap(([action]) =>
        this.lookupsService
          .readLookupWarrantyDeficiencies(action.includingInActive)
          .pipe(map(deficiencyCode => WarrantyActions.loadDeficiencyCodeSuccess({ deficiencyCode })))
      )
    )
  );
  loadLocations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(WarrantyActions.loadLocations),
      withLatestFrom(this.Locations$),
      switchMap(([action]) =>
        this.lookupsService
          .readLocations(action.includingInActive)
          .pipe(map(locations => WarrantyActions.loadLocationsSuccess({ locations })))
      )
    )
  );

  loadCategoryLocation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(WarrantyActions.selectedCategoryId),
      // withLatestFrom(this.store.select(selectProjectLots)),
      withLatestFrom(this.store.select(selectCategoryLocation)),
      switchMap(([action, categoryLocation]) => {
        // Extract projectId from selectedProject object
        const categoryId = action.categoryId && action.categoryId ? action.categoryId : null;
        const location = categoryLocation;
        if (categoryId && location && location.length > 0) {
          // Already in state, just dispatch success
          return of(WarrantyActions.loadCategoryLocation({ categoryLocation: { [categoryId]: location } }));
        } else if (categoryId) {
          // Not in state, fetch from API
          return this.lookupsService.readCategoryLocations(categoryId ?? '').pipe(
            map((result: any[]) => {
              const location = result || [];
              return WarrantyActions.loadCategoryLocation({ categoryLocation: { [categoryId ?? '']: location } });
            })
          );
        } else {
          // No projectId, return an empty observable (no action)
          return of();
        }
      })
    )
  );
}
